import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AlertNotice } from 'shared/components';
import Check from 'assets/svgs/check.svg';
import { isEmpty, sumBy } from 'lodash';
import { ROOM_STATUS } from 'shared/constants';
import { isRoomOnline, getRoomTimingName } from 'shared/helpers';

const validMaterialForRoomType = (materialTypesByRoomTypes, roomTypeID, materialTypeID) =>
  materialTypesByRoomTypes[roomTypeID] &&
  materialTypesByRoomTypes[roomTypeID].some((mType) => mType.id === materialTypeID);

const MaterialChainRoom = (props) => {
  const { t } = useTranslation();
  return (
    <div className="box">
      <div className="box-header">
        <div>
          <Link
            to={`/test-event/${props.tcEvent.id}/room/${props.room.id}`}
            href={`/test-event/${props.tcEvent.id}/room/${props.room.id}`}
            className="">
            {`${props.room.name} (${t('roomBuilder.seatsLabel', { total: props.room.capacity })})`}
          </Link>
          <span>
            {props.room.roomType
              ? props.room.roomType.name
              : t('testCenter.roomDashboard.noTypeLabel')}
          </span>
          {props.room.timing ? (
            <span>
              {getRoomTimingName(props.room.timing, props.tcEvent?.testingEvent?.adminId?.cycleId?.programId?.code, props.mappedRoomTiming)}
            </span>
          ) : null}
          {props.room.singleRoomFlag && <span>{t('rosters.singleRoom.label')}</span>}
          {props.room.roomType && (
            <span>
              {props.room.roomType.onlineFlag
                ? t('common.labels.online')
                : t('common.labels.paper')}
            </span>
          )}
        </div>
        <div>
          {/*{!isNull(props.scStatusIsCompleted) && !isUndefined(props.scStatusIsCompleted) &&*/}
          {/*<Link*/}
          {/*to={`/test-event/${props.tcEvent.id}/room/${props.room.id}/seating-chart`}*/}
          {/*href={`/test-event/${props.tcEvent.id}/room/${props.room.id}/seating-chart`}*/}
          {/*className=""*/}
          {/*>*/}
          {/*<span className={`sc-status ${props.scStatusIsCompleted ? 'completed': null}`}>*/}
          {/*<SeatIcon /> {t(props.scStatusIsCompleted ? 'seatingChart.statusCompleted' : 'seatingChart.statusStarted')}*/}
          {/*</span>*/}
          {/*</Link>*/}
          {/*}*/}
          {props.room.status !== ROOM_STATUS.inactive && (
            <span className={`room-status ${props.room.status}`}>
              {t('common.labels.room')} {ROOM_STATUS[props.room.status]}
            </span>
          )}
          <span className="supervisor">
            {t('testCenter.testMaterials.roomSupervisor')}:
            {!isEmpty(props.room.supervisor)
              ? `${props.room.supervisor.lastName}, ${props.room.supervisor.firstName}`
              : ` ${t('common.labels.unassigned')}`}
          </span>
        </div>
      </div>
      <div className="box-content">
        <div className="details">
          {props.room.roomType ? (
            isRoomOnline(props.room.roomType) ? (
              <span>{t('testCenter.testMaterials.noTestMaterialsOnlineMessage')}</span>
            ) : props.materialTypes && props.materialTypes.length ? (
              <React.Fragment>
                {props.materialTypes.map((materialType) =>
                  (props.materialTypesByRoomTypes &&
                    validMaterialForRoomType(
                      props.materialTypesByRoomTypes,
                      props.room.roomType.id,
                      materialType.id
                    )) ||
                  (props.roomMaterials && props.roomMaterials[materialType.id]) ? (
                    <div className="item" key={`material-type-${materialType.id}`}>
                      {!validMaterialForRoomType(
                        props.materialTypesByRoomTypes,
                        props.room.roomType.id,
                        materialType.id
                      ) &&
                        props.roomMaterials[materialType.id] && (
                          <AlertNotice
                            message={t('testCenter.testMaterialsRanges.warningRoomTypeNotMatch')}
                            type="warning"
                          />
                        )}
                      <div className="item-content">
                        <div className="item-title">
                          {materialType.name}
                          {props.roomMaterials && props.roomMaterials[materialType.id] && (
                            <span> ({sumBy(props.roomMaterials[materialType.id], 'count')})</span>
                          )}
                        </div>

                        <div className="item-details">
                          {props.roomMaterials &&
                          props.roomMaterials[materialType.id] &&
                          props.roomMaterials[materialType.id].length ? (
                            props.roomMaterials[materialType.id].map((material) => (
                              <div key={`room-material-${material.id}`}>
                                <span>{`${material.rangeBegin} - ${material.rangeEnd} (${material.count})`}</span>
                              </div>
                            ))
                          ) : (
                            <span>{t('testCenter.testMaterials.noRangesMaterialMessage')}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : null
                )}
              </React.Fragment>
            ) : (
              <span>
                {t(
                  isRoomOnline(props.room.roomType)
                    ? 'testCenter.testMaterials.noTestMaterialsOnlineMessage'
                    : 'testCenter.testMaterials.noTestMaterialsMessage'
                )}
              </span>
            )
          ) : (
            <span>
              {t(
                props.flagPaperEvent
                  ? 'testCenter.testMaterials.unknownRoomTypeMessage'
                  : 'testCenter.testMaterials.noTestMaterialsOnlineMessage'
              )}
            </span>
          )}
        </div>
        <div
          className={`actions ${
            !isRoomOnline(props.room.roomType) && props.flagPaperEvent ? 'paper-room' : ''
          }`}>
          {!props.room.confirmMaterialDateTime ? (
            <React.Fragment>
              {props.roomMaterials ? (
                <div className="action-btn">
                  <button
                    className="btn btn-outline btn-small"
                    onClick={() =>
                      props.goToRoomRanges(props.room, props.locationName, props.locationArea)
                    }>
                    {t(
                      isRoomOnline(props.room.roomType)
                        ? 'common.labels.edit'
                        : 'testCenter.testMaterials.editBtn'
                    )}
                  </button>
                </div>
              ) : (
                <div className="action-btn">
                  {!isRoomOnline(props.room.roomType) && props.flagPaperEvent && (
                    <button
                      className="btn btn-primary btn-small"
                      onClick={() =>
                        props.goToRoomRanges(props.room, props.locationName, props.locationArea)
                      }>
                      {t('testCenter.testMaterials.addBtn')}
                    </button>
                  )}
                </div>
              )}
            </React.Fragment>
          ) : (
            <div className="checked-section">
              <Check />
              <span>
                {t(
                  isRoomOnline(props.room.roomType)
                    ? 'materialChain.onlineSubmitted'
                    : 'materialChain.materialsSubmitted'
                )}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

MaterialChainRoom.propTypes = {
  roomMaterials: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  room: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    capacity: PropTypes.number,
    roomType: PropTypes.shape({
      name: PropTypes.string,
      onlineFlag: PropTypes.bool,
    }),
    timing: PropTypes.string,
    singleRoomFlag: PropTypes.bool,
    status: PropTypes.string,
    examineeCount: PropTypes.number,
  }).isRequired,
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  mappedRoomTiming: PropTypes.shape({}).isRequired,
  tcEventMaterialTypes: PropTypes.arrayOf(PropTypes.shape({})),
  materialTypesByRoomTypes: PropTypes.shape({}),
  submitModalOpen: PropTypes.bool,
  toggleSubmitRanges: PropTypes.func,
  onSubmitRanges: PropTypes.func,
  errorSubmitRanges: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  locationName: PropTypes.string.isRequired,
  locationArea: PropTypes.string,
};

export default MaterialChainRoom;
